import styled, {keyframes} from 'styled-components';

export const PlayerContainer = styled.div<{$isVisible: boolean}>`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #000;
    z-index: 9999;
    display: ${({$isVisible}) => ($isVisible ? 'flex' : 'none')};
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const CustomPlayerContainer = styled.div`
    width: 100%;
    height: 100%;
    background-color: #000;
    display: inline-flex;
`;

export const VideoContainer = styled.div`
    width: 75%;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const PlayerWrapper = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
`;

export const ProgressBar = styled.div`
    position: absolute;
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    height: 4px;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 2px;
    overflow: hidden;
`;

export const Progress = styled.div<{$progress: number}>`
    height: 100%;
    background-color: #ff0000;
    width: ${({$progress}) => $progress}%;
    transition: width 0.1s ease;
`;

export const TimeDisplay = styled.div`
    position: absolute;
    bottom: 90px;
    left: 50%;
    transform: translateX(-50%);
    color: white;
    font-size: 14px;
    font-weight: 500;
    background-color: rgba(0, 0, 0, 0.6);
    padding: 4px 8px;
    border-radius: 4px;
`;

export const DownloadListContainer = styled.div`
    width: 25%;
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0 6px 18px rgba(2, 6, 23, 0.6);
    color: #e6eef8;
    font-family:
        Inter,
        system-ui,
        -apple-system,
        'Segoe UI',
        Roboto,
        'Helvetica Neue',
        Arial;
`;

export const ListTitle = styled.h4`
    margin-bottom: 20px;
    font-size: 30px;
    font-weight: 600;
    color: #e6eef8;
    letter-spacing: -0.2px;
`;

export const TempList = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow-y: auto;
    padding-right: 4px;
    margin-bottom: 12px;

    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 3px;
    }
`;

export const TempItem = styled.div<{$focused?: boolean}>`
    padding: 8px 10px;
    border-radius: 8px;
    margin-bottom: 8px;
    font-size: 20px;
    color: #cfe8ff;
    background-color: ${({$focused}) => ($focused ? '#555' : '#333')};
    display: flex;
    align-items: center;
    justify-content: space-between;

    & img {
        width: 70px;
        height: 100%;
        margin-right: 10px;
    }
`;

export const BlackVideoListItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 12px;
    color: rgba(255, 255, 255, 0.5);
    text-align: center;
    padding: 40px 20px;
`;

export const TempItemLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 500px;
`;

export const TempItemRight = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const SelectButton = styled.button<{$focused: boolean; $isDelete?: boolean}>`
    background-color: ${({$isDelete}) => ($isDelete ? 'red' : 'green')};
    border: 2px solid ${({$focused}) => ($focused ? '#3ab8ff' : 'none')};
    border-radius: 20px;
    padding: 6px 14px;
    font-weight: bold;
    cursor: pointer;
    width: 80px;
    height: 40px;
    font-size: 13px;
    color: ${({$focused}) => ($focused ? '#000' : '#fff')};
    box-shadow: ${({$focused}) => ($focused ? '0 0 10px rgba(0, 191, 255, 1)' : 'none')};

    &:hover {
        background-color: #00bfff;
    }
`;

export const PlayBtn = styled.div`
    width: 30px;
    height: 10px;
    background-color: green;
    color: white;
`;

export const DeleteBtn = styled.div`
    width: 30px;
    height: 10px;
    background-color: red;
    color: white;
`;

export const InputArea = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 14px;
`;

export const FooterArea = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const UrlInput = styled.input`
    flex: 1;
    padding: 8px 10px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(0, 0, 0, 0.25);
    color: #e6eef8;
    font-size: 13px;
    outline: none;

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    &::placeholder {
        color: #7085a6;
    }
`;

export const DownloadButton = styled.button`
    padding: 0 14px;
    background: linear-gradient(90deg, #3b82f6, #06b6d4);
    border: none;
    border-radius: 8px;
    color: #ffffff;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: opacity 0.2s ease;

    &:hover {
        opacity: 0.85;
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }
`;

const LayoutButtonSlideUp = keyframes`
    from {
        transform: translate(-50%, 0%);
        visibility: hidden;
        opacity: 0;
    }
    to {
        transform: translate(-50%, -50%);
        visibility: visible;
        opacity: 1;
    }
`;

const LayoutButtonSlideDown = keyframes`
    from {
        transform: translate(-50%, -50%);
        visibility: visible;
        opacity: 1;
    }
    to {
        transform: translate(-50%, 0%);
        visibility: hidden;
        opacity: 0;
    }
`;

export const LayoutButton = styled.div<{$visible: boolean}>`
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    padding: 1rem;
    border-radius: 1rem;
    animation: ${({$visible}) => ($visible ? LayoutButtonSlideUp : LayoutButtonSlideDown)} 0.5s forwards;
`;

export const LayoutItem = styled.div<{$focused: boolean}>`
    display: flex;
    border: ${({$focused}) => ($focused ? '5px solid white' : 'none')};
    border-radius: 50%;
    margin: 1vw;
    background-color: ${({$focused}) => ($focused ? 'rgba(255, 255, 255, 0.2)' : '#000')};
    color: ${({$focused}) => ($focused ? '#fff' : '#000')};
`;

export const CloseButton = styled.button<{$focused: boolean}>`
    position: absolute;
    top: 20px;
    left: 20px;
    background-color: ${({$focused}) => ($focused ? '#fff' : 'rgba(255, 255, 255, 0.2)')};
    color: ${({$focused}) => ($focused ? '#000' : '#fff')};
    border: none;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: ${({$focused}) => ($focused ? 1 : 0.8)};

    &:hover {
        background-color: ${({$focused}) => ($focused ? '#fff' : 'rgba(255, 255, 255, 0.3)')};
    }
`;
